import { Route, Routes } from 'react-router-dom';
import './Landing.css';
import CommssionPages from './pages/Commission';
import Home from './pages/Home';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Promotion from './pages/Promotions';
import Products from './pages/Products';
import Affiliate from './pages/Affiliate';
import Contact from './pages/Contact';
import APIS from './common/Apis';
import React, { useState, useEffect } from 'react';

function LandingApp() {
  const [globalData, setGlobalData] = useState({});

  useEffect(() => {
    const fetchGeneral = async () => {
      let token = localStorage.getItem('token');
      let headers = {};
      if (token) {
        headers = { 'Authorization': `Bearer ${token}` };
      }
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/general`, {
          headers: headers
        });
        if (!response.ok) {
          throw new Error("Failed to fetch General");
        }
        const data = await response.json();
        if (data) {
          document.title = data[0].site_title;
          localStorage.setItem('whatsapp', data[0].whatsapp);
          localStorage.setItem('liveChat', data[0].live_chat);
          localStorage.setItem('intercom', data[0].intercom);
          localStorage.setItem('tawkId', data[0]?.tawk_id);
        }
      } catch (error) {
        console.error("Error fetching General:", error);
      }
    };
    fetchGeneral();
  }, []);

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!response.ok) {
          throw new Error("Failed to fetch logo");
        }
        const data = await response.json();
        const faviconUrl = `${process.env.REACT_APP_API_URL}/storage/${data[0].favicon}`;
        const link = document.querySelector("link[rel~='icon']");
        if (!link) {
          const newLink = document.createElement("link");
          newLink.rel = "icon";
          newLink.href = faviconUrl;
          document.head.appendChild(newLink);
        } else {
          link.href = faviconUrl;
        }
      } catch (error) {
        console.error("Error fetching logo:", error);
      }
    };
    fetchLogo();
  }, []);

  return (
    <div className="App">
      <APIS setGlobalData={setGlobalData} />
      <Routes>
        <Route index element={<Home globalData={globalData} />} />
        <Route path="commission-plan" element={<CommssionPages globalData={globalData} />} />
        <Route path="promotions" element={<Promotion sliderPromotion={globalData?.sliders?.promotion || []} />} />
        <Route path="products" element={<Products sliderProducts={globalData?.sliders?.product || []} />} />
        <Route path="affiliate-guide" element={<Affiliate sliderGuide={globalData?.sliders?.guide || []} />} />
        <Route path="contact-us" element={<Contact sliderContact={globalData?.sliders?.contact || []} globalData={globalData || []} />} />
      </Routes>
    </div>
  );
}

export default LandingApp;
